import ExternalLinksBaseHandler from '../external_links_base_handler';
import ServiceFactory from '../../../../services/service_factory';

export default class ExternalLinksPendingPlayHandler extends ExternalLinksBaseHandler {
    static CLASS = 'ExternalLinksPendingPlayHandler';
    static HandlerName = 'pending_play';

    executePostMessageAction(postMessageData) {
        if(postMessageData.Token) {
            this.close();
            ServiceFactory.create().pendingActionService().executeAction();
        } else {
            if ((postMessageData.ActionId || '').toLowerCase() === 'pending') {
                this.close();
            }
            this._clearOpenGamePendingAction();
        }
    }

    onBtnCloseClicked() {
        super.onBtnCloseClicked();
        this._clearOpenGamePendingAction();
    }

    getHandlerName() {
        return ExternalLinksPendingPlayHandler.HandlerName;
    }

    _clearOpenGamePendingAction() {
        ServiceFactory.create().pendingActionService().clearPendingAction();
    }

}